import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useTheme} from 'styled-components';
import {getMainColor} from 'styled/common';
import {useShareButtonStore} from './useShareButtonStore';
import {CustomIcon} from '@guestapp/ui';
import ModalSheet from 'components/common/ModalSheet';
import ShareRegistrationLink from 'components/ModalSheets/ShareRegistrationLink';
import {ShareBtnContainer, ShareText} from './styled';

function ShareButton() {
  const theme = useTheme();
  const {t} = useTranslation();
  const {isModalOpen, openModal, closeModal} = useShareButtonStore();

  useEffect(() => {
    return () => {
      closeModal();
    };
  }, [closeModal]);

  return (
    <>
      <ShareBtnContainer onClick={openModal} className="chekin-boxes__tasks-share-btn">
        <CustomIcon name="shareArrow" size={24} color={getMainColor(theme)} />
        <ShareText>{t('share')}</ShareText>
      </ShareBtnContainer>
      <ModalSheet
        isOpenModalSheet={isModalOpen}
        handleCloseModal={closeModal}
        maxWidth={'375px'}
        withCloseButton
      >
        <ShareRegistrationLink />
      </ModalSheet>
    </>
  );
}

export {ShareButton};
